export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7941.82476f82.jpg";